<template>
<div class="page_adressAdd">
    <div class="adress_form">
        <div class="item">
            <div class="item_l">公司名称</div>
            <div class="item_r">
                <van-field v-model="form.company" placeholder="请填写抬头名称" />
            </div>
        </div>
        <div class="item">
            <div class="item_l">税号</div>
            <div class="item_r">
                <van-field v-model="form.shuihao" type="tel" placeholder="请填写税号" />
            </div>
        </div>
        <!-- <div class="item">
            <div class="item_l">选择地区</div>
            <div class="item_r" @click="areaPicker=true">
                <van-field v-model="area" placeholder="请选择地区" readonly/>
            </div>
        </div> -->
        <div class="item">
            <div class="item_l_i">公司地址</div>
            <div class="item_r">
                <van-field v-model="form.address" placeholder="请填写公司地址" />
            </div>
        </div>
        <div class="item">
            <div class="item_l_i">公司电话</div>
            <div class="item_r">
                <van-field v-model="form.phone" placeholder="请填写公司电话" />
            </div>
        </div>
        <div class="item">
            <div class="item_l_i">开户行</div>
            <div class="item_r">
                <van-field v-model="form.bank" placeholder="请填写开户行" />
            </div>
        </div>
        <div class="item">
            <div class="item_l_i">银行账户</div>
            <div class="item_r">
                <van-field v-model="form.account" placeholder="请填写银行账户" />
            </div>
        </div>
    </div>
    <!-- <div class="default_adress">
        <div class="txt">设置默认发票</div>
        <div class="default_r">
            <van-switch v-model="checked" />
        </div>
    </div> -->
    <div class="action_wrap">
        <div class="action" @click="saveInvoice">保存</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            checked: true, // 是否默认
            form: {
                company: '',
                shuihao: '',
                address: '',
                phone: '',
                bank: '',
                account: '',
                is_default: 0,
            },
            id: this.$route.query.id,
            token: '',
            title: '新增发票',
        };
    },
    created: function () {
        if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
            //设置导航栏
            var params = {'data':{'naviTitle':'新增发票'}}
            if (this.$route.query.id) {
                params = {'data':{'naviTitle':'编辑发票'}}
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getInvoiceDetail()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getInvoiceDetail()
        }
        if (this.$route.query.id) {
            this.title = '编辑发票'
            window.document.title = '编辑发票'
        }

        
    },
    methods: {
        
        getInvoiceDetail() {
            if (this.id == null || this.id == undefined || this.id == '' ) {
                return
            }
            var params = {
                token: this.token,
                invoice_id: this.id,
            }
            this.$api.invoice.invoiceDetail(params).then(res=>{
                if (res.code == 200) {
                    var data = res.result
                    this.form = data
                } else {
                    this.$toast(res.message)
                }
            })
        },
        saveInvoice() {
            if (this.form.company == null || this.form.company == undefined || this.form.company == '') {
                this.$toast('请填写公司名称')
                return
            }
            if (this.form.shuihao == null || this.form.shuihao == undefined || this.form.shuihao == '') {
                this.$toast('请填写税号')
                return
            }
            var params = this.form
            params.token = this.token
            params.invoice_type = 0
            params.title = 1
            params.content = 0
            if (this.id && this.id != undefined && this.id != '') {
                params.invoice_id = this.id
            }
            this.$api.invoice.addInvoice(params).then(res=>{
                if (res.code == 200) {
                    this.$toast(res.message)
                    if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                        //返回上级页面
                        var params = {'data':{}}
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                        })
                    } else {
                        this.$router.back()
                    }
                    
                } else {
                    this.$toast(res.message?res.message:res.msg)
                }
            })
            
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
